import {
  LucideIcon,
  LayoutDashboard,
  PiggyBank,
  TrendingUp,
  CircleDollarSign,
  BarChart4,
  Shield,
  LineChart,
  Goal,
  Server,
  Calculator,
  Users,
  Split,
  BookOpen,
  Trophy,
  FileText,
  ClipboardCheck,
  MessageSquare,
  CreditCard,
} from "lucide-react";

export interface NavItem {
  title: string;
  label: string;
  icon: LucideIcon;
  href: string;
  requiresPremium?: boolean;
  submenu?: NavItem[]; // Submenu items for accordion
}

export const NAVIGATION_CONFIG = {
  main: [
    {
      title: "Dashboard",
      label: "",
      icon: LayoutDashboard,
      href: "/dashboard",
    },
    {
      title: "My Assets",
      label: "",
      icon: PiggyBank,
      href: "/assets",
    },
    {
      title: "Transactions",
      label: "",
      icon: TrendingUp,
      href: "/transactions",
    },
    {
      title: "Calculators",
      label: "",
      icon: Calculator,
      href: "/calculators",
    },
    {
      title: "SplitMage",
      label: "",
      icon: Split,
      href: "/splitmage",
    },
    {
      title: "Subscription",
      label: "",
      icon: CreditCard,
      href: "/subscription",
    },
    {
      title: "Blog",
      label: "",
      icon: BookOpen,
      href: "/blog",
      submenu: [
        {
          title: "All Posts",
          label: "",
          icon: BookOpen,
          href: "/blog",
        },
        {
          title: "Leaderboard",
          label: "",
          icon: Trophy,
          href: "/blog/leaderboard",
        },
        {
          title: "My Submissions",
          label: "",
          icon: FileText,
          href: "/blog/my-submissions",
        },
        {
          title: "Moderation",
          label: "",
          icon: ClipboardCheck,
          href: "/blog/moderation",
        },
        {
          title: "Comment Moderation",
          label: "",
          icon: MessageSquare,
          href: "/blog/moderation/comments",
        },
      ],
    },
  ],
  premium: [
    {
      title: "Family Hub",
      label: "Pro",
      icon: Users,
      href: "/family",
      requiresPremium: true,
    },
    {
      title: "Investments",
      label: "Pro",
      icon: CircleDollarSign,
      href: "/investments",
      requiresPremium: true,
    },
    {
      title: "Expenses",
      label: "Pro",
      icon: BarChart4,
      href: "/expenses",
      requiresPremium: true,
    },
    {
      title: "Reports & Sheets",
      label: "Pro",
      icon: LineChart,
      href: "/reports",
      requiresPremium: true,
    },
    {
      title: "Goals",
      label: "Pro",
      icon: Goal,
      href: "/goals",
      requiresPremium: true,
    },
  ],
  adminRoutes: [
    {
      title: "Admin",
      label: "",
      icon: Shield,
      href: "/admin",
    },
    {
      title: "System",
      label: "",
      icon: Server,
      href: "/system",
    },
  ],
} as const;

export type NavigationConfig = typeof NAVIGATION_CONFIG;
